export function createInvalidObservableTypeError(input) {
    return new TypeError("You provided ".concat(input !== null && typeof input === 'object' ? 'an invalid object' : "'".concat(input, "'"), " where a stream was expected. You can provide an Observable, Promise, ReadableStream, Array, AsyncIterable, or Iterable."));
}
//# sourceMappingURL=throwUnobservableError.js.map